export default "__VITE_ASSET__027c8f16__"